"use strict";
exports.__esModule = true;
exports.chart_color_red_300 = {
  "name": "--pf-chart-color-red-300",
  "value": "#7d1007",
  "var": "var(--pf-chart-color-red-300, #7d1007)"
};
exports["default"] = exports.chart_color_red_300;